<template>
    <div id="d3DIV">
        <svg width="878" height="927">
            <g transform="translate(80,30)">
                <g class="link-extensions">
                    <path d="M0,102.045458984375V21.925H628"></path>
                    <path d="M65.56881902464431,182.16591796875V65.77499999999999H628"></path>
                    <path d="M195.83848282953642,147.99375V109.625H628"></path>
                    <path d="M224.58135570588394,186.36249999999998V153.475H628"></path>
                    <path d="M199.87918072413737,326.13437500000003V285.02500000000003H628"></path>
                    <path d="M216.43849573256762,572.10546875V504.275H628"></path>
                    <path d="M299.2502705470549,219.25V197.32500000000002H628"></path>
                    <path d="M299.2502705470549,219.25V241.175H628"></path>
                    <path d="M220.2957645673232,367.24375000000003V328.875H628"></path>
                    <path d="M231.2955954172117,405.6125V372.72499999999997H628"></path>
                    <path d="M344.1280760082653,570.0500000000001V548.125H628"></path>
                    <path d="M344.1280760082653,570.0500000000001V591.975H628"></path>
                    <path d="M271.57728208466585,438.5V416.575H628"></path>
                    <path d="M271.57728208466585,438.5V460.425H628"></path>
                    <path d="M307.03243234373434,657.75V635.8249999999999H628"></path>
                    <path d="M307.03243234373434,657.75V679.6750000000001H628"></path>
                    <path d="M267.1713951870195,761.8937500000001V723.525H628"></path>
                    <path d="M279.1949887151335,800.2624999999999V767.375H628"></path>
                    <path d="M371.6200735886941,833.15V811.225H628"></path>
                    <path d="M371.6200735886941,833.15V855.0749999999999H628"></path>
                </g>
                <g class="links">
                    <path d="M0,102.045458984375V21.925H628" stroke="#1f77b4"></path>
                    <path d="M0,102.045458984375V182.16591796875H65.56881902464431" stroke="#1f77b4"></path>
                    <path d="M65.56881902464431,182.16591796875V65.77499999999999H628" stroke="#ff7f0e"></path>
                    <path d="M65.56881902464431,182.16591796875V298.5568359375H148.02776522610594" stroke="#ff7f0e"></path>
                    <path d="M148.02776522610594,298.5568359375V147.99375H195.83848282953642" stroke="#2ca02c"></path>
                    <path d="M148.02776522610594,298.5568359375V449.119921875H169.9252104508339" stroke="#2ca02c"></path>
                    <path d="M195.83848282953642,147.99375V109.625H628" stroke="#d62728"></path>
                    <path d="M195.83848282953642,147.99375V186.36249999999998H224.58135570588394" stroke="#d62728"></path>
                    <path d="M169.9252104508339,449.119921875V326.13437500000003H199.87918072413737"
                        stroke="#d62728"></path>
                    <path d="M169.9252104508339,449.119921875V572.10546875H216.43849573256762" stroke="#d62728"></path>
                    <path d="M224.58135570588394,186.36249999999998V153.475H628" stroke="#9467bd"></path>
                    <path d="M224.58135570588394,186.36249999999998V219.25H299.2502705470549" stroke="#9467bd"></path>
                    <path d="M199.87918072413737,326.13437500000003V285.02500000000003H628" stroke="#9467bd"></path>
                    <path d="M199.87918072413737,326.13437500000003V367.24375000000003H220.2957645673232"
                        stroke="#9467bd"></path>
                    <path d="M216.43849573256762,572.10546875V504.275H628" stroke="#9467bd"></path>
                    <path d="M216.43849573256762,572.10546875V639.9359375H218.74849435610525" stroke="#9467bd"></path>
                    <path d="M299.2502705470549,219.25V197.32500000000002H628" stroke="#8c564b"></path>
                    <path d="M299.2502705470549,219.25V241.175H628" stroke="#8c564b"></path>
                    <path d="M220.2957645673232,367.24375000000003V328.875H628" stroke="#8c564b"></path>
                    <path d="M220.2957645673232,367.24375000000003V405.6125H231.2955954172117" stroke="#8c564b"></path>
                    <path d="M218.74849435610525,639.9359375V570.0500000000001H344.1280760082653" stroke="#8c564b"></path>
                    <path d="M218.74849435610525,639.9359375V709.821875H251.31743282936975" stroke="#8c564b"></path>
                    <path d="M231.2955954172117,405.6125V372.72499999999997H628" stroke="#e377c2"></path>
                    <path d="M231.2955954172117,405.6125V438.5H271.57728208466585" stroke="#e377c2"></path>
                    <path d="M344.1280760082653,570.0500000000001V548.125H628" stroke="#e377c2"></path>
                    <path d="M344.1280760082653,570.0500000000001V591.975H628" stroke="#e377c2"></path>
                    <path d="M251.31743282936975,709.821875V657.75H307.03243234373434" stroke="#e377c2"></path>
                    <path d="M251.31743282936975,709.821875V761.8937500000001H267.1713951870195" stroke="#e377c2"></path>
                    <path d="M271.57728208466585,438.5V416.575H628" stroke="#7f7f7f"></path>
                    <path d="M271.57728208466585,438.5V460.425H628" stroke="#7f7f7f"></path>
                    <path d="M307.03243234373434,657.75V635.8249999999999H628" stroke="#7f7f7f"></path>
                    <path d="M307.03243234373434,657.75V679.6750000000001H628" stroke="#7f7f7f"></path>
                    <path d="M267.1713951870195,761.8937500000001V723.525H628" stroke="#7f7f7f"></path>
                    <path d="M267.1713951870195,761.8937500000001V800.2624999999999H279.1949887151335"
                        stroke="#7f7f7f"></path>
                    <path d="M279.1949887151335,800.2624999999999V767.375H628" stroke="#bcbd22"></path>
                    <path d="M279.1949887151335,800.2624999999999V833.15H371.6200735886941" stroke="#bcbd22"></path>
                    <path d="M371.6200735886941,833.15V811.225H628" stroke="#17becf"></path>
                    <path d="M371.6200735886941,833.15V855.0749999999999H628" stroke="#17becf"></path>
                </g>
                <g class="labels">
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,21.925)"
                        text-anchor="start">茯苓
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,65.77499999999999)"
                        text-anchor="start">人参
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,109.625)"
                        text-anchor="start">杏仁
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,153.475)"
                        text-anchor="start">半夏
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,197.32500000000002)"
                        text-anchor="start">陈皮
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,241.175)"
                        text-anchor="start">厚朴
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,285.02500000000003)"
                        text-anchor="start">白芍
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,328.875)"
                        text-anchor="start">炙甘草
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,372.72499999999997)"
                        text-anchor="start">桂枝
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,416.575)"
                        text-anchor="start">白术
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,460.425)"
                        text-anchor="start">当归
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,504.275)"
                        text-anchor="start">茯神
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,548.125)"
                        text-anchor="start">地黄
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,591.975)"
                        text-anchor="start">阿胶
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,635.8249999999999)"
                        text-anchor="start">麦冬
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,679.6750000000001)"
                        text-anchor="start">甘草
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,723.525)"
                        text-anchor="start">黄连
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,767.375)"
                        text-anchor="start">牡丹皮
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,811.225)"
                        text-anchor="start">熟地黄
                    </text>
                    <text dx="1em" dy="0.31em" style="font-size:20px;" transform="translate(628,855.0749999999999)"
                        text-anchor="start">五味子
                    </text>
                </g>
            </g>
            <g transform="translate(80,20)" fill="none" font-size="12" font-family="sans-serif" text-anchor="middle">
                <path class="domain" stroke="#000" d="M628.5,-6V0.5H0.5V-6"></path>
                <g class="tick" opacity="1" transform="translate(628.5,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">0</text>
                </g>
                <g class="tick" opacity="1" transform="translate(539.6162528196493,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">5</text>
                </g>
                <g class="tick" opacity="1" transform="translate(450.7325056392985,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">10</text>
                </g>
                <g class="tick" opacity="1" transform="translate(361.8487584589477,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">15</text>
                </g>
                <g class="tick" opacity="1" transform="translate(272.965011278597,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">20</text>
                </g>
                <g class="tick" opacity="1" transform="translate(184.0812640982462,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">25</text>
                </g>
                <g class="tick" opacity="1" transform="translate(95.19751691789543,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">30</text>
                </g>
                <g class="tick" opacity="1" transform="translate(6.313769737544703,0)">
                    <line stroke="#000" y2="-6"></line>
                    <text fill="#000" y="-9" dy="0em">35</text>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
 #d3DIV {
        width: 100%;
        height: 100%;
        margin-top: 25px;
    }

    #show-length {
        position: absolute;
        top: 10px;
        left: 10px;
    }

    .links {
        fill: none;
        stroke: #000;
    }

    .link-extensions {
        fill: none;
        stroke: #000;
        stroke-opacity: .25;
    }

    .labels {
        font: 10px sans-serif;
    }

    .link--active {
        stroke: #000 !important;
        stroke-width: 1.5px;
    }

    .link-extension--active {
        stroke-opacity: .6;
    }

    .label--active {
        font-weight: bold;
    }
</style>